
const Container=({children,className=""})=>{

    return <div className={`mx-auto w-11/12 md:w-6/12 lg:w-5/12 xl:w-4/12   ${className}`}>{children}</div>
}
export default Container;